<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.billings && wrapper">
  <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
    [businesses]="localService.loggedMember.businesses"></app-business-deductive>
  <div class="banner center" style="max-width:1000px;">
    <div class="row freeze_height">
      <div [ngClass]="interactionType != 1 ? 'col-md-8' : 'col-12'">
        <div class="row">
          <div class="col-7">
            <div style="margin-top: 10px;">
              <app-search-token [isTitle]="false" (onSearchToken)="onSearchToken($event)"
                [businessId]="businessId"></app-search-token>
            </div>
          </div>
          <div class="col-5">
            <ngx-select *ngIf="localService.billingStatus" [(ngModel)]="selectedStatus" [allowClear]="true"
              [optionValueField]="'key'" [optionTextField]="'value'" [items]="localService.billingStatus"
              (select)="onLoad()" [noAutoComplete]="true" (remove)="onLoad()"
              placeholder="{{localService.languageContent.billings.status}}"
              title="{{localService.languageContent.billings.status}}">
            </ngx-select>
          </div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="interactionType != 1">
        <div style="margin-top: 10px;">
          <app-business-relationship [businessId]="businessId" (onUserUpdated)="onUserUpdated($event)"
            [relationShipType]="relationShipType" [relationShipRole]="relationShipRole"></app-business-relationship>
        </div>
      </div>
    </div>
    <div class="row row_header freeze_height">
      <div class="col-md-6">
        <div class="row">
          <div class="col-8">
            <button *ngIf="interactionType != 1" class="button_icon button_icon_color"
              [disabled]="wrapper.items.length == 0" (click)="onAction(2)"
              style="color: red !important;top: 5px;float: left;">
              delete
            </button>
            <label *ngIf="isExcludedEnabled" style="font-weight: normal; margin-left: 15px;"
              title="{{localService.languageContent.common.is_excluded}}">
              <input type="checkbox" [(ngModel)]="isExcluded" (change)="onGetBills()" />
              <span class="normal_color">&nbsp;</span>
            </label>
            {{localService.languageContent.billings.token}}
          </div>
          <div class="col-4">
            {{localService.languageContent.billings.status}}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-6">
            {{interactionType != 1 ? localService.languageContent.billings.customer :
            localService.languageContent.billings.seller}}
          </div>
          <div class="col-6">
            {{localService.languageContent.table.created_on}}
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper.items">
        <div class="col-md-6">
          <div class="row">
            <div class="col-8 wrap-div">
              <button class="button_icon button_icon_color" style="top: 5px;" (click)="onAction(1,item.key)">
                more_horiz
              </button>
              <span class="button" [ngClass]="item.v2 == '' ? '' : 'en'" (click)="onOpenBilling(item.key)">
                {{item.v2 == '' ? localService.languageContent.billings.draft : item.v2}}
              </span>
              <span class="en">&nbsp;{{item.v8}}</span>
            </div>
            <div class="col-4 wrap-div">
              <i [ngClass]="item.v9 == '1' ? 'bill_paid' : 'bill_not_paid'"
                class="material-icons icon_adjust bill_paid">paid</i>
              {{localService.getText(localService.billingStatus,item.v5)}}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-6 wrap-div">
              <span class="button" (click)="localService.showSummary(item.v3,interactionType != 1 ? 1 : 2)"
                [ngClass]="localService.getLanguageCode(item.v4)">{{item.v1}}</span>
            </div>
            <div class="col-6 wrap-div">
              <span class="en">{{item.v7 | date : 'dd-MMM-yyyy hh:mm a'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging [paging]="wrapper.paging" [IsSimple]="true" [IsShowSimpleCalenderRange]="true"
    [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
  <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onDelete($event)"
    [IsPopup]="true" />
  <app-otp-container *ngIf="isShowOtpPopup" [IsOtpPopup]="true" (onVerified)="onVerifiedOtp($event)"
    [businessId]="businessId" [otpType]="OtpType.DeleteBills" [interactionType]="interactionType"
    (onCancelled)="isShowOtpPopup = false" />
  <app-send-to-phone *ngIf="isOpenSendToPhone" [(isOpen)]="isOpenSendToPhone" [key]="selectedId"
    [communicationTemplate]="CommunicationTemplate.SendBillToPhone" />
  <app-more-actions [(isOpenPopup)]="isActionPopupOpen" [items]="moreActionItems" [title]="actionTitle"
    (onClicked)="onMoreActionClicked($event)" />
</div>